import Component from '@galactic-advisors/component-loader';
import axios from 'axios';

const DEFAULTS = {
  calculateImplementationsButtonElement:
    '[data-calculate-implementations-button]',
  checkboxElements: '[data-checkbox-element]',
  formElement: '[data-auto-add-implementations-form]',
  modalCloseButtonElement: '[data-modal-close-button]',
  modalFinishButtonElement: '[data-modal-finish-button]',
  loaderElement: '[data-loader]',
  tableContainerElement: '[data-table-container]',
  tableContainerBodyElement: '[data-table-container-body]',
  titleContainerElement: '[data-title-container]',
  toastMessageContainerElement: '[data-toast-message-container]',
  toastMessageElement: '[data-toast-message]',
};

export default class AutoAddImplementationsModal extends Component {
  static selector = '[data-comp-auto-add-implementation-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.modalCloseButton = this.$container.querySelector(
      this.$options.modalCloseButtonElement
    );

    this.modalFinishButton = this.$container.querySelector(
      this.$options.modalFinishButtonElement
    );

    this.calculateImplementationsBtn = this.$container.querySelector(
      this.$options.calculateImplementationsButtonElement
    );

    this.form = this.$container.querySelector(this.$options.formElement);
    this.fetchRoute = this.calculateImplementationsBtn.dataset.calculateRoute;
    this.loader = this.$container.querySelector(this.$options.loaderElement);
    this.tableContainer = this.$container.querySelector(
      this.$options.tableContainerElement
    );
    this.tableContainerBody = this.$container.querySelector(
      this.$options.tableContainerBodyElement
    );
    this.titleContainer = this.$container.querySelector(
      this.$options.titleContainerElement
    );

    this.toastMessageContainer = this.$container.querySelector(
      this.$options.toastMessageContainerElement
    );

    this.toastMessage = this.$container.querySelector(
      this.$options.toastMessageElement
    );

    this.initListeners();
  }

  checkIfAnyChecked() {
    return Array.from(
      this.$container.querySelectorAll(this.$options.checkboxElements)
    ).some((checkbox) => checkbox.checked);
  }

  fetchImplementationOptions() {
    const implementationOptions = axios({
      method: 'get',
      url: this.fetchRoute,
    }).catch((error) => {
      this.toastMessageContainer.classList.remove('d-none');
      this.toastMessage.innerText = error.response.data.message;
    });
    return implementationOptions;
  }

  hydrateTable(responseData) {
    responseData.forEach((implementation) => {
      this.tableContainer.classList.remove('d-none');
      this.tableContainerBody.insertAdjacentHTML('beforeend', implementation);
    });
  }

  initCheckboxListener() {
    this.$container.querySelectorAll(this.$options.checkboxElements) &&
      this.$container
        .querySelectorAll(this.$options.checkboxElements)
        .forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            this.modalFinishButton.disabled = !this.checkIfAnyChecked();
          });
        });
  }

  initListeners() {
    this.modalFinishButton.addEventListener('click', (event) => {
      event.preventDefault();

      if (this.checkIfAnyChecked()) {
        this.form.submit();
      }
    });

    this.calculateImplementationsBtn.addEventListener(
      'click',
      async (event) => {
        event.preventDefault();
        this.loader.classList.remove('d-none');
        this.titleContainer.classList.add('d-none');
        this.fetchImplementationOptions().then((resp) => {
          this.loader.classList.add('d-none');
          if (resp && resp.data.data) {
            this.hydrateTable(resp.data.data);
            this.initCheckboxListener();
          } else {
            this.modalFinishButton.disabled = true;
            this.toastMessageContainer.classList.remove('d-none');
            this.toastMessage.innerText = resp.data.message;
          }
        });
      }
    );
  }
}
